/* src/app/admin-dashboard/site-system/inventory/stock-filler/stock-filler.component.css */
.matIcon {
  cursor: pointer;
}
/*# sourceMappingURL=stock-filler.component.css.map */
